var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSaveWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9608 13.6171H2.44487C2.08433 13.6171 1.73856 13.4739 1.48362 13.219C1.22867 12.964 1.08545 12.6183 1.08545 12.2577V2.74175C1.08545 2.38121 1.22867 2.03543 1.48362 1.78049C1.73856 1.52555 2.08433 1.38232 2.44487 1.38232H9.9217L13.3203 4.78088V12.2577C13.3203 12.6183 13.177 12.964 12.9221 13.219C12.6672 13.4739 12.3214 13.6171 11.9608 13.6171Z",
    stroke: "white",
    strokeWidth: 1.35942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6013 13.6169V8.1792H3.8042V13.6169",
    stroke: "white",
    strokeWidth: 1.35942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M3.8042 1.38208V4.78064H9.24189",
    stroke: "white",
    strokeWidth: 1.35942,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaveWhite);
export default __webpack_public_path__ + "static/media/saveWhite.0257dd26c74088420557adf4c8ba51bd.svg";
export { ForwardRef as ReactComponent };